import React from 'react';
import {
    Form, Input, Button,
} from 'antd';
import { useHistory } from 'react-router-dom';
import { loginUserRequest } from 'modules/authModule/requests/authRequest';

import './Login.scss';


const Login = ({ setToken, setUserId }: { setToken?: any, setUserId?: any }):JSX.Element => {
    const history = useHistory();
    const [form] = Form.useForm();

    const onSubmitSuccess = (values: any) => {
        loginUserRequest({
            usernameOrEmail: values.usernameOrEmail,
            password: values.password,
        }).then(data => {
            if (data) {
                form.resetFields();
                const {userId, ...accessTokenObject} = data;
                setToken({
                    ...accessTokenObject, userId,
                });
                setUserId(data.userId);
                history.push("/");
            }
            else {
                form.resetFields();
            }
        });
    };

    return (
        <div className="login-form">
            <Form
                name="basic"
                labelCol={{
                    span: 8,
                }}
                wrapperCol={{
                    span: 16,
                }}
                initialValues={{
                    remember: true,
                }}
                form={form}
                onFinish={onSubmitSuccess}
                autoComplete="off"
            >
                <Form.Item
                    label="Nazwa użytkownika"
                    name="usernameOrEmail"
                    rules={[{
                        required: true, message: 'Proszę podać nazwę użytkownika',
                    }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Hasło"
                    name="password"
                    rules={[{
                        required: true, message: 'Proszę podać hasło',
                    }]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item wrapperCol={{
                    offset: 8, span: 16,
                }}>
                    <Button type="primary" htmlType="submit">
                        Zaloguj
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};

export default Login;
